import { loadFont as l } from "./DynamicKit.js";
async function d(e, r, a, c, n) {
  n = n || "Ag";
  try {
    await l(e, r, { dynamic: !0, style: a, weight: c, unicodeRange: g(n) });
  } catch {
    return Promise.resolve(null);
  }
  const t = document.createElement("canvas");
  t.width = 375, t.height = 300, t.style.background = "#ffffff";
  const o = t.getContext("2d");
  if (!o) return Promise.resolve(null);
  const i = t.height / 2;
  return o.font = `${i}px ${e}`, o.textAlign = "center", o.fillText(n, t.width / 2, t.height / 2 + 0.25 * i), await new Promise((s) => t.toBlob(s));
}
function g(e) {
  return e.split("").map((r) => `U+${r.charCodeAt(0).toString(16).padStart(4, "0")}`).join(",");
}
export {
  d as generatePreviewImage,
  g as getUnicodeRange
};
//# sourceMappingURL=PreviewImageGenerator.js.map
